














import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { IMenuItem, IMoreMenuItem } from '@/components/global/UserMenuMobile/UserMenuMobileMainMenu/constants';

@Component<UserMenuMobileMainMenuItem>({
  name: 'UserMenuMobileMainMenuItem',
})
export default class UserMenuMobileMainMenuItem extends Vue {
  @Prop({ required: true }) item!: IMenuItem | IMoreMenuItem;
  @Prop({ default: true }) highlightActiveRoute!: boolean;
  @Prop({ default: false }) isNew!: boolean;

  get icon(): string {
    return this.isNew
      ? require(`./images/${this.item.icon}-icon-new.vue.svg`)
      : require(`./images/${this.item.icon}-icon.vue.svg`);
  }

  get rootComponent(): string {
    if (this.item.isLink) {
      return 'a';
    }

    return this.item.to ? 'NuxtLink' : 'button';
  }

  get isCurrentRouteIsActive(): boolean {
    const isActive = !!this.item.route?.some(route => this.$route.path.startsWith(route));
    return this.item.to?.name === this.$route.name || isActive;
  }

  get rootClass(): Record<string, boolean> {
    return {
      'user-menu-mobile-main-menu-item': true,
      'user-menu-mobile-main-menu-item--active':
        this.item.isActive || (this.highlightActiveRoute && this.isCurrentRouteIsActive),
    };
  }

  get sanitizeItem() {
    const { route, action, visible, icon, ...rest } = this.item;
    return rest;
  }
}
